export default "__VITE_ASSET__BzYqLENR__"